import {Component, OnInit, OnDestroy} from '@angular/core';
import {ChartsVccService} from '../../../service/charts-vcc.service';
import moment from 'moment';
import {DatePipe} from '@angular/common';
import {Observable, of, Subscription, catchError, finalize} from 'rxjs';
import {VccChartFilterResult} from '../../../model/funding-vcc-chart-filter';

@Component({
    selector: 'app-vcc-component',
    templateUrl: './vcc.component.html',
    standalone: false
})

export class VccComponent implements OnInit, OnDestroy {

    public formattedTodayDate: string = '';
    public releasedDateFrom: string = '';
    public totalDays: number = 0;
    public titleWidget: string = 'Selected Date Range Interval';
    public latestReleasedDate$: Observable<VccChartFilterResult> = new Observable();
    public isLoading: boolean = true;
    public isError: boolean = false;

    private subscriptions: Subscription[] = [];

    constructor(private chartsVccService: ChartsVccService,
                private datePipe: DatePipe
    ) {}

    ngOnInit() {
        this.isLoading = true;
        this.isError = false;

        const today = moment();
        this.latestReleasedDate$ = this.chartsVccService.getVccChartFilter();

        const filterSub = this.latestReleasedDate$.subscribe(
            (releasedDate) => {
                if(releasedDate.releasedDateFrom) {
                    this.updateTotalDays(releasedDate.releasedDateFrom);
                    this.isLoading = false;
                } else {
                    const dateSub = this.chartsVccService.getLatestDate()
                        .pipe(
                            catchError(error => {
                                console.error('Error getting latest date in VCC component:', error);
                                this.isError = true;
                                const fallbackDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                                return of(fallbackDate);
                            }),
                            finalize(() => {
                                this.isLoading = false;
                            })
                        )
                        .subscribe(
                            (latestReleasedDate) => {
                                this.releasedDateFrom = this.datePipe.transform(latestReleasedDate, 'EEE MMM dd yyyy') || '';
                                this.updateTotalDays(latestReleasedDate);
                                this.isError = false;
                            },
                            (error) => {
                                console.error('Failed to get latest date:', error);
                                this.isError = true;
                                this.isLoading = false;
                            }
                        );

                    this.subscriptions.push(dateSub);
                }
            },
            (error) => {
                console.error('Error subscribing to chart filter:', error);
                this.isError = true;
                this.isLoading = false;
            }
        );

        this.subscriptions.push(filterSub);
        this.formattedTodayDate = this.datePipe.transform(today.toDate(), 'EEE MMM dd yyyy') || '';
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    private updateTotalDays(latestReleasedDate: string | Date) {
        const today = moment();
        const startDate = moment(latestReleasedDate);
        this.totalDays = today.diff(startDate, 'days') + 1;
    }

    get dateFilterText() {
        let dateFilterText = '';
        this.chartsVccService.getDateSubTitle().subscribe((subTitle) => {
            dateFilterText = subTitle.replace(/\(|\)/g, '');
        });
        return dateFilterText;
    }

    refreshData() {
        this.isLoading = true;
        this.isError = false;

        const today = moment();
        const oneMonthAgo = moment().subtract(1, 'month');

        this.chartsVccService.setVccChartFilter({
            releasedDateFrom: oneMonthAgo.toDate(),
            releasedDateTo: today.toDate()
        });
    }
}
